<script setup lang="ts">
import { ElTooltip } from 'element-plus'
import { ref } from 'vue'

interface Props {
  text: string | number | null | undefined
  placement?: 'top' | 'bottom' | 'left' | 'right'
  offset?: number
}

const props = withDefaults(defineProps<Props>(), {
  placement: 'top',
  offset: 4,
})

const spanRef = ref<HTMLSpanElement | null>(null)
const isOverflowing = ref(false)

// Detect overflow lazily on hover so we don't measure every cell at
// mount/render time — ElTable can render hundreds of rows.
function checkOverflow() {
  const el = spanRef.value
  isOverflowing.value = !!el && el.scrollWidth > el.clientWidth
}

function displayText() {
  if (props.text === null || props.text === undefined)
    return ''
  return String(props.text)
}
</script>

<template>
  <ElTooltip
    :content="displayText()"
    :placement="placement"
    :offset="offset"
    :show-after="300"
    :disabled="!isOverflowing || !displayText()"
    effect="light"
  >
    <span
      ref="spanRef"
      class="block truncate"
      @mouseenter="checkOverflow"
    >
      {{ displayText() }}
    </span>
  </ElTooltip>
</template>
